import React from 'react';
import { Row, Col } from 'react-bootstrap';
import GoogleAuthButton from './GoogleAuthButton';
import MagicLinkForm from './MagicLinkForm';

const AuthContainer = ({ 
    email, 
    setEmail, 
    onGoogleAuth, 
    onMagicLinkSubmit, 
    disabled = false,
    googleButtonText,
    magicLinkButtonText,
    showDivider = true,
    containerClassName = "auth-container"
}) => {
    // Validate required props
    if (!googleButtonText || !magicLinkButtonText) {
        console.error('AuthContainer: googleButtonText and magicLinkButtonText are required props');
        return null;
    }

    return (
        <div className={containerClassName}>
            {/* Google OAuth Button - Always enabled */}
            <Row className="mb-4">
                <Col className="text-center">
                    <GoogleAuthButton 
                        onClick={onGoogleAuth}
                        disabled={false}
                        text={googleButtonText}
                    />
                </Col>
            </Row>
            
            {/* OR Divider */}
            {showDivider && (
                <Row className="mb-4">
                    <Col>
                        <div className="auth-divider">
                            <hr />
                            <span>OR</span>
                            <hr />
                        </div>
                    </Col>
                </Row>
            )}
            
            {/* Magic Link Form */}
            <Row>
                <Col>
                    <MagicLinkForm 
                        email={email}
                        setEmail={setEmail}
                        onSubmit={onMagicLinkSubmit}
                        disabled={disabled}
                        buttonText={magicLinkButtonText}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default AuthContainer;
